//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import loadingElementTemplate from '@legacy-components/common/loading-element/loading-element.html';

(function() {
  const curalate = angular.module('curalate');

  curalate.component('loadingElement', {
    bindings: {
      height: '@?',
    },
    template: loadingElementTemplate,
  });
})();
